export type PaymentEntityType = 'course' | 'class' | 'balance'

const PAYMENT_ENTITY_LABELS: Record<PaymentEntityType, string> = {
  course: 'Курс',
  class: 'Класс',
  balance: 'Баланс',
}

export const formatPaymentEntityLabel = (
  type: PaymentEntityType,
  name?: string | null,
) => `${PAYMENT_ENTITY_LABELS[type]}: ${name?.trim() || '-'}`
